import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteBillingNote } from '../api/DeleteBillingNote';

interface DeleteBillingNoteParams {
  billingUuid: string;
  noteUuid: string;
}

export const useDeleteBillingNote = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({ billingUuid, noteUuid }: DeleteBillingNoteParams) =>
      deleteBillingNote(billingUuid, noteUuid),
    onSuccess: async (_, { billingUuid }) => {
      await queryClient.invalidateQueries({
        queryKey: ['billing-notes', billingUuid],
      });
      await queryClient.invalidateQueries({ queryKey: ['billings'] });
    },
  });

  return { deleteNote: mutateAsync, isPending };
};
